import { OpenGameBook } from './OpenGameBook';

export default OpenGameBook;
